import { TentTypeV1 } from '@camp67/model';
import { proxy } from 'valtio';

export const tentModal = proxy({
  isOpen: false,
  type: null as TentTypeV1 | null,
});

export const onOpenTentModal = (type: TentTypeV1 | null) => {
  tentModal.isOpen = true;
  tentModal.type = type;
};

export const onCloseTentModal = () => {
  tentModal.isOpen = false;
  tentModal.type = null;
};
